import { render, staticRenderFns } from "./AiKLingVideo.vue?vue&type=template&id=1c84767d&scoped=true"
import script from "./AiKLingVideo.vue?vue&type=script&lang=js"
export * from "./AiKLingVideo.vue?vue&type=script&lang=js"
import style0 from "./AiKLingVideo.vue?vue&type=style&index=0&id=1c84767d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c84767d",
  null
  
)

export default component.exports